<template>
  <div class="lesson-container">
      <h3>Lesson Two: Turkish Alphabet -- Vowels and Consonants</h3>
      <p>The Turkish alphabet also called Türk alfabesi in Turkish contains 29 letters.</p>
  </div>
</template>

<script>
export default {
  name: "TurkishLessonOne",
  props: {
      currentLanguage: {type: String},
  },
  data() {
    return {
     
    };
  },
  methods: {
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
